import { configureStore } from '@reduxjs/toolkit';

import invoices from './invoice/invoicesSlice';

// Most UI state stays local to the tabs; the invoices slice is the shared
// list cache so switching tabs doesn't refetch (and doesn't lose data).
const store = configureStore({
	reducer: {
		invoices,
	},
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
